import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withStyles, Typography } from '@material-ui/core';
import PF2MSearchButton from '~/components/PF2MSearchButton';
import styles from './styles';

const SearchHeader = ({ classes, setOpenModal }) => {
  const { t: translate } = useTranslation();
  const filters = useSelector(state => state.expedite.expediteDailyPartsFilters);
  const materials = useSelector(state => state.manager.materials);
  const expediteMaterials = useSelector(state => state.expedite.expediteMaterials);
  const subElements = useSelector(state => state.manager.subElements);

  const externalProduct = expediteMaterials.find(
    r => r?.external_product_id === filters?.external_product_id,
  );
  const subElement = subElements.find(r => r?.id === filters?.element_point_id);
  const externalProductName = materials.find(r => r?.id === externalProduct?.material_id)?.name;
  const subElementName = subElements.find(r => r?.id === subElement?.id)?.name;

  const {
    startDate = moment(new Date()),
    endDate = moment(new Date()),
  } = filters;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <div className={classes.searchHeaderContainer}>
      <div className={classes.searchHeaderContent}>
        <Typography variant="caption" className={classes.resultsForText}>
          {`${translate('common:ResultsFor')}:`}
        </Typography>
        <div className={classes.searchHeaderInfoContainer}>
          {startDate && endDate
            && (
              <div className={classes.infoContainer}>
                <Typography className={classes.dataText} variant="body1">
                  {moment(startDate).format(translate('date:DateFormat'))}
                  {' '}
                  -
                  {' '}
                  {moment(endDate).format(translate('date:DateFormat'))}
                </Typography>
              </div>
            )}
          {externalProductName && (
            <div className={classes.infoContainer}>
              <Typography className={classes.infoKeyText} variant="body1">
                {`, ${translate('common:Material')}:`}
              </Typography>
              <Typography className={classes.dataText} variant="body1">
                {externalProductName}
              </Typography>
            </div>
          )}
          {subElementName && (
            <div className={classes.infoContainer}>
              <Typography className={classes.infoKeyText} variant="body1">
                {`, ${translate('common:OriginPoint')}:`}
              </Typography>
              <Typography className={classes.dataText} variant="body1">
                {subElementName}
              </Typography>
            </div>
          )}
        </div>
      </div>
      <div>
        <PF2MSearchButton size="medium" onClick={handleOpenModal} />
      </div>
    </div>
  );
};

SearchHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
};

SearchHeader.defaultProps = {};

export default withStyles(styles)(SearchHeader);
